import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Layout } from 'antd';
import useWindowSize from '../../library/hooks/useWindowSize';
import { toggleAll } from '../../redux-new/app/app.slice';
import {
  PrivateMainLayoutContainer,
  PrivateMainLayoutGlobalStyles,
} from './PrivateMainLayout.styles';
import Topbar from '../../pages/Topbar/Topbar';
import Sidebar from '../../pages/Sidebar/Sidebar';
import siteConfig from '../../config/site.config';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { PUBLIC_ROUTE } from '../../route.constants';
import { getSonyToolProp } from '../../redux-new/sony-tool-prop-slice/sony-tool-prop-slice';

const { Content, Footer } = Layout;

const styles = {
  layout: { flexDirection: 'row', overflowX: 'hidden' },
  content: {
    padding: '70px 0 0',
    flexShrink: '0',
    background: '#f1f3f6',
    position: 'relative',
  },
  footer: {
    background: '#ffffff',
    textAlign: 'center',
    borderTop: '1px solid #ededed',
  },
};

export default function PrivateMainLayout(props) {
  const dispatch = useDispatch();
  const appHeight = useSelector((state) => state.app.height);
  const { width, height } = useWindowSize();
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useSelector((state) => state.auth);
  const feProperties = useSelector(getSonyToolProp);

  React.useEffect(() => {
    dispatch(toggleAll({ width: width, height: height }));
  }, [width, height, dispatch]);

  React.useEffect(() => {
    if (!auth.isLoggedIn) {
      navigate(PUBLIC_ROUTE.SIGN_IN, { state: { from: location.pathname } });
    }

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return auth.isLoggedIn ? (
    <PrivateMainLayoutContainer>
      <PrivateMainLayoutGlobalStyles />
      <Layout style={{ height: height }}>
        <Topbar />
        <Layout style={styles.layout}>
          <Sidebar />
          <Layout
            className="isoContentMainLayout"
            style={{
              height: appHeight,
            }}
          >
            <Content className="isomorphicContent" style={styles.content}>
              <Outlet />
            </Content>
            <Footer style={styles.footer}>
              {siteConfig.getSiteFooter(feProperties.lastBuildVersionFeWa)}
            </Footer>
          </Layout>
        </Layout>
        {/* <ThemeSwitcher /> */}
      </Layout>
    </PrivateMainLayoutContainer>
  ) : (
    <Navigate to={PUBLIC_ROUTE.SIGN_IN} state={{ from: location.pathname }} />
  );
}
